import { Star, Quote, ChevronLeft, ChevronRight, MapPin } from 'lucide-react';
import { useState, useEffect } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    location: 'Hyderabad',
    avatar: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBtYW4lMjBwb3J0cmFpdHxlbnwxfHx8fDE3NjY5MTcyNjJ8MA&ixlib=rb-4.1.0&q=80&w=150',
    rating: 5,
    review: 'Exceptional service and comfortable rooms! The location is perfect - close to the airport and main attractions. The staff went above and beyond to make our stay memorable. Highly recommended for both business and leisure travelers.',
    date: '2 weeks ago',
    roomType: 'Suite Room',
    verified: true,
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Chennai',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3b21hbiUyMHBvcnRyYWl0fGVufDF8fHx8MTc2NjkxNzI2Mnww&ixlib=rb-4.1.0&q=80&w=150',
    rating: 5,
    review: 'Clean, comfortable, and great value for money. The room was spacious and well-maintained. The location in Old Gajuwaka made it very convenient for our travel plans. Will definitely stay here again!',
    date: '1 month ago',
    roomType: 'Royal Room',
    verified: true,
  },
  {
    id: 3,
    name: 'Amit Patel',
    location: 'Mumbai',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBtYW4lMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDF8fHx8MTc2NjkxNzI2Mnww&ixlib=rb-4.1.0&q=80&w=150',
    rating: 4,
    review: 'Perfect for business travelers. The Wi-Fi was fast, rooms were quiet, and the staff was professional. The location near the airport saved us a lot of time. Good amenities at a reasonable price.',
    date: '3 weeks ago',
    roomType: 'Single Room',
    verified: true,
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    location: 'Bangalore',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3b21hbiUyMHBvcnRyYWl0fGVufDF8fHx8MTc2NjkxNzI2Mnww&ixlib=rb-4.1.0&q=80&w=150',
    rating: 5,
    review: 'Outstanding hospitality! The team made us feel at home. The rooms were spotless and the location is excellent. Great place to stay when visiting Visakhapatnam. The breakfast was delicious too!',
    date: '2 months ago',
    roomType: 'Suite Room',
    verified: true,
  },
  {
    id: 5,
    name: 'Vikram Singh',
    location: 'Delhi',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBtYW4lMjBwcm9mZXNzaW9uYWx8ZW58MXx8fHwxNzY2OTE3MjYyfDA&ixlib=rb-4.1.0&q=80&w=150',
    rating: 4,
    review: 'Great value for money! The hotel exceeded our expectations. Clean rooms, friendly staff, and excellent location. The AC worked perfectly and the Wi-Fi was reliable. Recommended for families.',
    date: '1 month ago',
    roomType: 'Royal Room',
    verified: true,
  },
];

export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-16 sm:py-24 bg-luxury-gradient relative overflow-hidden">
      {/* Luxury Background Pattern */}
      <div className="absolute inset-0 bg-luxury-pattern opacity-20"></div>
      
      <div className="relative w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block glass-luxury border border-gold-400/30 text-gold-300 px-6 py-3 rounded-full text-sm font-medium mb-6">
            Luxury Guest Experiences
          </div>
          <h2 className="mb-6 text-white">What Our Distinguished Guests Say</h2>
          <p className="text-cream-200 max-w-3xl mx-auto text-lg">
            Don't just take our word for it. Here's what our valued guests have to say about their luxury experience at Hotel A.S.K Grand.
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div className="relative max-w-4xl mx-auto mb-12">
          <div className="glass-luxury rounded-3xl shadow-luxury-xl p-8 md:p-12 relative overflow-hidden border border-gold-400/20">
            {/* Background Quote Icon */}
            <Quote className="absolute top-6 right-6 w-20 h-20 text-gold-400/20 transform rotate-12" />
            
            {/* Rating Stars */}
            <div className="flex items-center gap-1 mb-8">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-6 h-6 ${
                    i < currentTestimonial.rating
                      ? 'text-gold-400 fill-current'
                      : 'text-cream-400'
                  }`}
                />
              ))}
              <span className="ml-3 text-sm text-cream-300 font-medium">
                {currentTestimonial.rating}.0 out of 5 stars
              </span>
            </div>

            {/* Review Text */}
            <blockquote className="text-xl md:text-2xl text-cream-100 leading-relaxed mb-10 font-medium">
              "{currentTestimonial.review}"
            </blockquote>

            {/* Guest Info */}
            <div className="flex items-center gap-6">
              <div className="relative">
                <img
                  src={currentTestimonial.avatar}
                  alt={currentTestimonial.name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-gold-400 shadow-gold"
                />
                {currentTestimonial.verified && (
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gold-400 rounded-full flex items-center justify-center shadow-gold">
                    <svg className="w-4 h-4 text-navy-900" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
              
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h4 className="font-bold text-gold-400 text-lg">{currentTestimonial.name}</h4>
                  {currentTestimonial.verified && (
                    <span className="text-xs bg-gold-400/20 text-gold-300 px-3 py-1 rounded-full font-semibold border border-gold-400/30">
                      Verified Luxury Guest
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-4 text-sm text-cream-300">
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-gold-400" />
                    <span>{currentTestimonial.location}</span>
                  </div>
                  <span className="text-gold-400">•</span>
                  <span>Stayed in {currentTestimonial.roomType}</span>
                  <span className="text-gold-400">•</span>
                  <span>{currentTestimonial.date}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-14 h-14 glass-luxury border border-gold-400/30 rounded-full shadow-luxury hover:shadow-gold-xl transition-all duration-300 flex items-center justify-center group hover:scale-110"
          >
            <ChevronLeft className="w-7 h-7 text-gold-400 group-hover:text-gold-300" />
          </button>
          
          <button
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-14 h-14 glass-luxury border border-gold-400/30 rounded-full shadow-luxury hover:shadow-gold-xl transition-all duration-300 flex items-center justify-center group hover:scale-110"
          >
            <ChevronRight className="w-7 h-7 text-gold-400 group-hover:text-gold-300" />
          </button>
        </div>

        {/* Testimonial Indicators */}
        <div className="flex justify-center gap-4 mb-16">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`transition-all duration-300 ${
                index === currentIndex
                  ? 'w-10 h-4 bg-gold-400 rounded-full shadow-gold'
                  : 'w-4 h-4 bg-cream-400/50 rounded-full hover:bg-cream-400'
              }`}
            />
          ))}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          <div className="glass-luxury rounded-3xl p-8 shadow-luxury text-center border border-gold-400/20">
            <div className="text-4xl font-bold text-gold-400 mb-3">4.8</div>
            <div className="text-sm text-cream-300 mb-3">Average Rating</div>
            <div className="flex justify-center">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 text-gold-400 fill-current" />
              ))}
            </div>
          </div>
          
          <div className="glass-luxury rounded-3xl p-8 shadow-luxury text-center border border-gold-400/20">
            <div className="text-4xl font-bold text-gold-400 mb-3">500+</div>
            <div className="text-sm text-cream-300">Distinguished Guests</div>
          </div>
          
          <div className="glass-luxury rounded-3xl p-8 shadow-luxury text-center border border-gold-400/20">
            <div className="text-4xl font-bold text-gold-400 mb-3">98%</div>
            <div className="text-sm text-cream-300">Luxury Satisfaction</div>
          </div>
          
          <div className="glass-luxury rounded-3xl p-8 shadow-luxury text-center border border-gold-400/20">
            <div className="text-4xl font-bold text-gold-400 mb-3">24/7</div>
            <div className="text-sm text-cream-300">Concierge Service</div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <p className="text-cream-200 mb-8 text-lg">Ready to create your own memorable luxury experience?</p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-gold-gradient text-navy-900 px-12 py-5 rounded-2xl font-bold text-lg hover:shadow-gold-xl transition-all duration-300 transform hover:scale-105 pulse-luxury"
          >
            Reserve Your Luxury Suite Today
          </button>
        </div>
      </div>
    </section>
  );
}